enum FormMode {
  NONE = 0,
  EDIT = 1,
  CREATE = 2,
}

export default FormMode;
